import { Check, ContentPasteOff, Fastfood, Gesture, Hotel, LaptopMac, Repeat, Send } from '@mui/icons-material'
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineSeparator } from '@mui/lab'
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import { Stack, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment';
import { COLORS } from 'shared/constants/AppEnums';
import { blue, green, purple, red } from '@mui/material/colors';

const LogHistory = ({ data = [] }) => {
    return (
        <Timeline
            sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                },
                padding: '0 !important'
            }}
        >
            {
                data.map((item, index) => (
                    <>
                        <TimelineItem key={index}>
                            <TimelineSeparator>
                                {/* {index > 0 && <TimelineConnector />} */}
                                <TimelineConnector />
                                <TimelineDot
                                    sx={{
                                        backgroundColor: item.action === 'revisi' || item.action === 'revision' || item.action === 'return' ? red[100] : item.action === 'paraf' ? green[100] : item.action === 'submit' ? blue[100] : item.action === 'approve' ? purple[100] : null,
                                        color: item.action === 'revisi' || item.action === 'revision' || item.action === 'return' ? red[500] : item.action === 'paraf' ? green[500] : item.action === 'submit' ? blue[500] : item.action === 'approve' ? purple[500] : null,
                                        boxShadow: 'none'
                                    }}
                                >
                                    {
                                        item.action === 'revisi' || item.action === 'revision' || item.action === 'return' ? <ContentPasteOff /> :
                                            item.action === 'paraf' ? <Gesture /> :
                                                item.action === 'approve' ? <Check /> :
                                                    item.action === 'submit' ? <Send /> : null
                                    }
                                </TimelineDot>
                                <TimelineConnector />
                                {/* {index < data.length - 1 && <TimelineConnector />} */}
                            </TimelineSeparator>
                            <TimelineContent sx={{ py: '12px', px: 2 }}>
                                <Stack spacing={1}>
                                    <Stack>
                                        <Typography fontWeight={'bold'}>{item.user}</Typography>
                                        <Typography variant='h6' component={'span'} color={'GrayText'}>{moment(item.created_at).format('DD MMMM YYYY | HH:mm:ss')}</Typography>
                                    </Stack>

                                    <Typography textTransform={'capitalize'}>{item.message}</Typography>
                                </Stack>
                            </TimelineContent>
                        </TimelineItem>
                    </>
                ))
            }
        </Timeline>
    )
}

LogHistory.propTypes = {
    data: PropTypes.array
}

export default LogHistory